import Vue from 'vue'
import VueRouter from 'vue-router'
// 导入 components
import StepRegister from '@/views/Register/StepRegister'
import ProducerRegister from '@/views/Register/ProducerRegister'
import SupplierRegister from '@/views/Register/SupplierRegister'
import ForgotPassword from '@/views/Forgot/ForgotPassword'
import MyAccount from '@/views/Member/MyAccount'
import EnrollOnline from '@/views/Member/EnrollOnline'
import BiddingOnline from '@/views/Member/BiddingOnline'
import MyDeclare from '@/views/Member/MyDeclare'
import DownloadTools from '@/views/Declare/DownloadTools'
import ExpertReview from '@/views/Member/ExpertReview'
import MgrDeclare from '@/views/Member/MgrDeclare'
import OnlineMeeting from '@/views/Meeting/OnlineMeeting'
import BusinessQA from '@/views/Member/BusinessQA'
import ConcernedAbout from '@/views/Member/ConcernedAbout'

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history', // 路由配置: 跳转 url, 不带 /#/...
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/enrollonline'
    },
    {
      path: '/producer/register',
      component: ProducerRegister
    },
    {
      path: '/supplier/register',
      component: SupplierRegister
    },
    {
      path: '/member/register',
      component: StepRegister
    },
    {
      path: '/member/forgot',
      component: ForgotPassword
    },
    {
      path: '/myaccount',
      component: MyAccount
    },
    {
      path: '/onlinemeeting',
      component: OnlineMeeting
    },
    {
      path: '/enrollonline',
      component: EnrollOnline
    },
    {
      path: '/biddingonline',
      component: BiddingOnline
    },
    {
      path: '/mydeclare',
      component: MyDeclare
    },
    {
      path: '/download',
      component: DownloadTools
    },
    {
      path: '/expertreview',
      component: ExpertReview
    },
    {
      path: '/mgrdeclare',
      component: MgrDeclare
    },
    {
      path: '/businessqa',
      component: BusinessQA
    },
    {
      path: '/concerned',
      component: ConcernedAbout
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/router.js